'use client'
import MUITextField from '@mui/material/TextField'
import type { SxProps } from '@mui/material'
import { useState, useEffect } from 'react'
const DEBOUNCE_TIME = 1000
import { TEXT_FIELD_VARIANTS } from '@/CommonComponents/constants'

interface ITextFieldProp {
  id?: string
  variant?: 'filled' | 'outlined' | 'standard'
  placeholder?: string
  multiline?: boolean
  sx?: SxProps
  rows?: number
  value?: string
  type?: 'email' | 'password' | 'text'
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: () => void
  autoFocus?: boolean
  size?: 'small' | 'medium'
}
const MUI_TEXT_FIELD_VARIANTS = {
  [TEXT_FIELD_VARIANTS.FILLED]: 'filled',
  [TEXT_FIELD_VARIANTS.OUTLINED]: 'outlined',
  [TEXT_FIELD_VARIANTS.STANDARD]: 'standard',
} as const

export default function TextField({
  id,
  variant = 'standard',
  placeholder = '',
  sx,
  multiline,
  rows,
  value,
  type = 'text',
  onChange,
  onBlur,
  size = 'small',
  autoFocus,
}: ITextFieldProp) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onChange && debouncedValue !== value) {
        onChange({ target: { value: debouncedValue } } as React.ChangeEvent<HTMLInputElement>)
      }
    }, DEBOUNCE_TIME)
    return () => {
      clearTimeout(timer)
    }
  }, [debouncedValue, onChange, value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDebouncedValue(e.target.value)
  }

  return (
    <MUITextField
      id={id}
      label={placeholder}
      multiline={multiline}
      variant={MUI_TEXT_FIELD_VARIANTS[variant]}
      sx={sx}
      rows={rows}
      value={debouncedValue}
      type={type}
      size={size}
      onChange={handleChange}
      onBlur={onBlur}
      autoFocus={autoFocus}
    />
  )
}
